@if(error) {
  <div class="alert alert-danger">{{ error }}</div>
}
<h1 data-automation-name="marketContextEditor">
  @switch(editing) {
    @case(true) {
      <span>Edit Market Context {{marketContextId}}</span>
    }
    @case(false) {
      <span>Register a new Market Context</span>
    }
  }
</h1>
<form [formGroup]="marketContextForm" class="form-horizontal">
  <div class="form-group">
    <label for="marketContextId">Market context uri:</label>
    <input id="marketContextId" class="form-control" name="market_context" type="text" formControlName="market_context" required>
  </div>
  <div class="form-group">
    <label for="operator">Operator:</label>
    <input id="operator" class="form-control" name="operator" type="text" formControlName="operator" required>
  </div>
  <div class="form-group">
    <label for="program">Program:</label>
    <input id="program" class="form-control" name="program" type="text" formControlName="program" required>
  </div>
  <div class="form-group">
    <label for="product">Product:</label>
    <input id="product" class="form-control" name="product" type="text" formControlName="product">
  </div>
  <div class="form-group">
    <label for="actionType">Action type:</label>
    <select id="actionType" class="form-control" name="actionType" type="select" formControlName="action_type">
      <option data-automation-name="blank" value="" selected></option>
      <option data-automation-name="OFFICIAL" value="OFFICIAL">Official</option>
      <option data-automation-name="VOLUNTARY" value="VOLUNTARY">Voluntary</option>
    </select>
  </div>
  <div class="form-group">
    <label for="label">Label:</label>
    <input id="label" class="form-control" name="label" type="text" formControlName="label">
  </div>

  <div class="row">
    <div class="col-md-6">
      <label for="included_groups">Included Groups</label>
      <table id="included_groups" class="table table-striped">
        <thead>
        <tr>
          <th colspan="4">
            <input placeholder="Search" class="input-sm form-control" type="search" [(ngModel)]="searchTextIncludedGroups" [ngModelOptions]="{standalone: true}" />
          </th>
        </tr>
        <tr>
          <th></th>
          <th>ID</th>
          <th>Group ID</th>
          <th>Division</th>
        </tr>
        </thead>
        <tbody>
          @for(group of displayedIncludedGroups | searchFilterPipe : searchTextIncludedGroups : 'group_id' | paginate: includedGroupsPagination; track group) {
            <tr id="group_included_{{group.id}}" class="table-active">
              <td><button id="remove" class="btn btn-primary" type="button" (click)="removeGroup(group)">Remove</button></td>
              <td>{{group.id}}</td>
              <td>{{group.group_id}}</td>
              <td>{{group.division}}</td>
            </tr>
          }
          @if(displayedIncludedGroups.length === 0) {
            <tr>
              <td colspan="4" style="text-align: center;">No groups included.</td>
            </tr>
          }
        </tbody>
        <tfoot>
        <tr>
          <td class="text-center" colspan="4">
            <pagination-controls id="includedGroupsPagination" (pageChange)="handleIncludedGroupsPageChange($event)" class="my-pagination"></pagination-controls>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>

    <div class="col-md-6">
      <label for="possible_groups">Possible Groups</label>
      <table id="possible_groups" class="table table-striped">
        <thead>
        <tr>
          <th colspan="4">
            <input placeholder="Search" class="input-sm form-control" type="search" [(ngModel)]="searchTextPossibleGroups" [ngModelOptions]="{standalone: true}" />
          </th>
        </tr>
        <tr>
          <th></th>
          <th>ID</th>
          <th>Group ID</th>
          <th>Division</th>
        </tr>
        </thead>
        <tbody>
          @for(group of displayedPossibleGroups | searchFilterPipe : searchTextPossibleGroups : 'group_id' | paginate: possibleGroupsPagination; track group) {
            <tr id="group_possible_{{group.id}}" class="table-active">
              <td><button id="include" class="btn btn-primary" type="button" (click)="includeGroup(group)">Include</button></td>
              <td>{{group.id}}</td>
              <td>{{group.group_id}}</td>
              <td>{{group.division}}</td>
            </tr>
          }
          @if(displayedPossibleGroups.length === 0) {
            <tr>
              <td colspan="4" style="text-align: center;">No Groups exist yet.</td>
            </tr>
          }
        </tbody>
        <tfoot>
        <tr>
          <td class="text-center" colspan="4">
            <pagination-controls id="possibleGroupsPagination" (pageChange)="handlePossibleGroupsPageChange($event)" class="my-pagination"></pagination-controls>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <button id="save" class="btn btn-primary" type="button" (click)="save()">Save</button>
  <a class="btn" (click)="backPage('/marketContexts', router)">Cancel</a>
</form>
